import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { React, useState, useEffect, lazy, Suspense } from "react";
import MainLayout from "./componments/main-layout";
import HomePageComponent from "./componments/pages/home/home-page";
import RegisterPageComponent from "./componments/pages/register/register-page";
import StoryPageComponent from "./componments/pages/story/story-page";
import PersonalChartPageComponent from "./componments/pages/personal-chart/personal-chart-page";
import LibraryCenterCompontent from "./componments/pages/library/library-center-page";
import LibraryArticleCompontent from "./componments/pages/library-article/library-article-page";
import StorePageComponent from "./componments/pages/store/store-page";
import FortuneServicePageComponent from "./componments/pages/fortune-service/fortune-service-page";
import PersonalBoardComponent from "./componments/pages/personal-board/personal-board-page";
import PersonalEditorComponent from "./componments/pages/personal-editor/personal-editor-page";
import StudyRoomCompontent from "./componments/pages/study-room/study-room-page";
import PointStoreCompontent from "./componments/pages/point-store/point-store-page";
import PurchaseRecordCompontent from "./componments/pages/purchase-record/purchase-record-page";
import PurchaseDetailCompontent from "./componments/pages/purchase-detail/purchase-detail-page";
import ConsultPageCompontent from "./componments/pages/consult/professional-consult-page";
import AskTeacherComponent from "./componments/pages/ask-teacher/ask-teacher-page";
import LoveMatchEnterComponent from "./componments/product/love-match/enter/love-match-enter";
import LoveMatchReportComponent from "./componments/product/love-match/report/love-match-report";
import FlowYearEnterComponent from "./componments/product/flow-year/enter/flow-year-enter";
import FlowYearReportComponent from "./componments/product/flow-year/report/flow-year-report";
import QimenDunjiaEnterPage from "./componments/pages/qimen-dunjia/enter/qimen-dunjia-enter-page";
import QimenDunjiaPassPage from "./componments/pages/qimen-dunjia/pass/qimen-dunjia-pass-page";
import QimenDunjiaResultPage from "./componments/pages/qimen-dunjia/result/qimen-dunjia-result-page";
import FamilyMatchEnterComponent from "./componments/product/family-match/enter/family-match-enter";
import FamilyMatchReportComponent from "./componments/product/family-match/report/family-match-report";
import PointRecordCompontent from "./componments/pages/point-record/point-record-page";
import CheckoutPageComponent from "./componments/pages/checkout/checkout-page";
import PolicyPageComponent from "./componments/pages/policy/policy-page";
import LandingPageComponent from "./componments/pages/landing-page/landing-page";
import DeleteAccountPageComponent from "./componments/pages/delete-account/delete-account-page";

//後台 admin 獨立切成 lazy chunk：一般使用者不進 /admin 就不會下載這包 JS
const AdminApp = lazy(() => import("./componments/admin/admin-app"));

//每次路由變化（pathname 改變）→ 自動捲到頂端
//  解決：所有頁面進入時要置頂，不用每個 page component 自己加 useEffect
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  let [showServiceMenu, setShowServiceMenu] = useState(false);
  let [showPersonalMenu, setShowPersonalMenu] = useState(false);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route
          path="/"
          element={
            <MainLayout
              showServiceMenu={showServiceMenu}
              setShowServiceMenu={setShowServiceMenu}
              showPersonalMenu={showPersonalMenu}
              setShowPersonalMenu={setShowPersonalMenu}
            />
          }
        >
          {/*命理首頁*/}
          <Route
            index
            element={
              <HomePageComponent
                setShowServiceMenu={setShowServiceMenu}
                setShowPersonalMenu={setShowPersonalMenu}
              />
            }
          />
          {/*註冊頁*/}
          <Route
            path="register"
            element={
              <RegisterPageComponent
                setShowServiceMenu={setShowServiceMenu}
                setShowPersonalMenu={setShowPersonalMenu}
              />
            }
          />
          {/*導航-品牌故事*/}
          <Route
            path="story"
            element={
              <StoryPageComponent
                setShowServiceMenu={setShowServiceMenu}
                setShowPersonalMenu={setShowPersonalMenu}
              />
            }
          />
          {/*導航-個人專屬命盤*/}
          <Route
            path="personal-chart"
            element={
              <PersonalChartPageComponent
                setShowServiceMenu={setShowServiceMenu}
                setShowPersonalMenu={setShowPersonalMenu}
              />
            }
          />
          {/*命理服務*/}
          <Route
            path="fortune-service"
            element={
              <FortuneServicePageComponent
                setShowServiceMenu={setShowServiceMenu}
                setShowPersonalMenu={setShowPersonalMenu}
              />
            }
          />
          {/*導航-雲閣藏書*/}
          <Route
            path="library"
            element={
              <LibraryCenterCompontent
                setShowServiceMenu={setShowServiceMenu}
                setShowPersonalMenu={setShowPersonalMenu}
              />
            }
          />

          {/*雲閣藏書-指定文章*/}
          <Route
            path="article/:articleID"
            element={
              <LibraryArticleCompontent
                setShowServiceMenu={setShowServiceMenu}
                setShowPersonalMenu={setShowPersonalMenu}
              />
            }
          />

          {/*導航-雲上雜貨店*/}
          <Route path="store" element={<StorePageComponent />} />

          {/*個人檔案*/}
          <Route
            path="personal-board"
            element={
              <PersonalBoardComponent
                setShowServiceMenu={setShowServiceMenu}
                setShowPersonalMenu={setShowPersonalMenu}
              />
            }
          />

          {/*編輯個人檔案*/}
          <Route
            path="personal-editor"
            element={
              <PersonalEditorComponent
                setShowServiceMenu={setShowServiceMenu}
                setShowPersonalMenu={setShowPersonalMenu}
              />
            }
          />

          {/*我的書房*/}
          <Route
            path="study-room"
            element={
              <StudyRoomCompontent
                setShowServiceMenu={setShowServiceMenu}
                setShowPersonalMenu={setShowPersonalMenu}
              />
            }
          />

          {/*點數管理*/}
          <Route
            path="point"
            element={
              <PointStoreCompontent
                setShowServiceMenu={setShowServiceMenu}
                setShowPersonalMenu={setShowPersonalMenu}
              />
            }
          />

          {/*點數紀錄*/}
          <Route
            path="point-record"
            element={
              <PointRecordCompontent
                setShowServiceMenu={setShowServiceMenu}
                setShowPersonalMenu={setShowPersonalMenu}
              />
            }
          />

          {/*購買記錄*/}
          <Route
            path="purchase-record"
            element={
              <PurchaseRecordCompontent
                setShowServiceMenu={setShowServiceMenu}
                setShowPersonalMenu={setShowPersonalMenu}
              />
            }
          />

          {/*購買明細*/}
          <Route
            path="purchase-detail"
            element={
              <PurchaseDetailCompontent
                setShowServiceMenu={setShowServiceMenu}
                setShowPersonalMenu={setShowPersonalMenu}
              />
            }
          />

          {/*專業諮詢*/}
          <Route
            path="consult"
            element={
              <ConsultPageCompontent
                setShowServiceMenu={setShowServiceMenu}
                setShowPersonalMenu={setShowPersonalMenu}
              />
            }
          />

          {/*問問老師*/}
          <Route
            path="ask-teacher"
            element={
              <AskTeacherComponent
                setShowServiceMenu={setShowServiceMenu}
                setShowPersonalMenu={setShowPersonalMenu}
              />
            }
          />

          {/*真愛合盤入口*/}
          <Route
            path="love-enter"
            element={
              <LoveMatchEnterComponent
                setShowServiceMenu={setShowServiceMenu}
                setShowPersonalMenu={setShowPersonalMenu}
              />
            }
          />

          {/*真愛合盤報告*/}
          <Route
            path="love-report"
            element={
              <LoveMatchReportComponent
                setShowServiceMenu={setShowServiceMenu}
                setShowPersonalMenu={setShowPersonalMenu}
              />
            }
          />

          {/*流年之書入口*/}
          <Route
            path="flow-enter"
            element={
              <FlowYearEnterComponent
                setShowServiceMenu={setShowServiceMenu}
                setShowPersonalMenu={setShowPersonalMenu}
              />
            }
          />

          {/*奇門遁甲：3 頁面 — enter（介紹）/ pass（過程）/ result（結果）*/}
          <Route
            path="qimen-dunjia"
            element={
              <QimenDunjiaEnterPage
                setShowServiceMenu={setShowServiceMenu}
                setShowPersonalMenu={setShowPersonalMenu}
              />
            }
          />
          <Route path="qimen-dunjia/pass" element={<QimenDunjiaPassPage />} />
          <Route path="qimen-dunjia/result" element={<QimenDunjiaResultPage />} />

          {/*流年之書報告*/}
          <Route
            path="flow-report"
            element={
              <FlowYearReportComponent
                setShowServiceMenu={setShowServiceMenu}
                setShowPersonalMenu={setShowPersonalMenu}
              />
            }
          />

          {/*親子合盤入口*/}
          <Route
            path="family-enter"
            element={
              <FamilyMatchEnterComponent
                setShowServiceMenu={setShowServiceMenu}
                setShowPersonalMenu={setShowPersonalMenu}
              />
            }
          />

          {/*結帳頁（全站購買流程統一收斂在這頁：選發票 → 送出 → 綠界）*/}
          <Route
            path="checkout"
            element={
              <CheckoutPageComponent
                setShowServiceMenu={setShowServiceMenu}
                setShowPersonalMenu={setShowPersonalMenu}
              />
            }
          />

          {/*隱私權政策與使用條款（一頁兩 tab）*/}
          <Route
            path="policy"
            element={
              <PolicyPageComponent
                setShowServiceMenu={setShowServiceMenu}
                setShowPersonalMenu={setShowPersonalMenu}
              />
            }
          />

          {/*親子合盤報告*/}
          <Route
            path="family-report"
            element={
              <FamilyMatchReportComponent
                setShowServiceMenu={setShowServiceMenu}
                setShowPersonalMenu={setShowPersonalMenu}
              />
            }
          />
        </Route>

        {/* aAibo App 介紹頁：獨立 landing，不繼承 MainLayout / nav */}
        <Route path="/aaibo" element={<LandingPageComponent />} />

        {/* 刪除帳號（公開頁；Google 審核規範）：獨立 route、不繼承 MainLayout / nav */}
        <Route path="/delete-account" element={<DeleteAccountPageComponent />} />

        {/* 後台 admin：與使用者端平行的兄弟路由，不繼承 MainLayout / nav */}
        <Route
          path="/admin/*"
          element={
            <Suspense fallback={<div>載入中…</div>}>
              <AdminApp />
            </Suspense>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
